import React, { useState } from 'react';
import { MCButton, MCText, View } from 'src/components/basic';
import { scssVariables as variables, userFullName } from 'src/helpers';

import { remCss, remFontCss, tabs } from 'src/components/mobile/utils';
import SVGIcon, { BASE_ICONS } from '../svg';
import LangSelect from '../LangSelect';
import { useNavigate } from 'react-router-dom';
import LANG_CONST from '../../helpers/lang/const';
import HospitalAvatar from 'src/assets/images/clinic-profile.png';

export const ClinicHeader = ({ clinic, activeTab, onActiveTab }) => {
  const [isOpen, setOpen] = useState(false);
  let navigate = useNavigate();
  return (
    <View>
      <View
        style={{
          paddingHorizontal: remCss(15),
          paddingVertical: remCss(20),
          backgroundColor: 'white',
          ...(isOpen && {
            borderBottom: `1px solid ${variables['colors-mc-border']}`,
            zIndex: 1
          })
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCss(15)
          }}
        >
          <img
            style={{
              width: remCss(70),
              height: remCss(70),
              borderRadius: remCss(5),
              borderColor: variables['colors-mc-border2'],
              borderWidth: 1,
              borderStyle: 'solid',
              objectFit: 'cover'
            }}
            src={clinic.avatar || HospitalAvatar}
          />
          <View style={{ gap: remCss(3), flex: 1 }}>
            <MCText heading label={userFullName(clinic)} size={remFontCss(21)} weight={700} />
            <MCText
              heading
              label={clinic.description}
              size={remFontCss(17)}
              weight={400}
              numberOfLines={1}
            />
          </View>
          <View
            className={`mc-dropdown-menu ${isOpen ? 'open' : ''}`}
            style={{ alignSelf: `flex-start` }}
          >
            <MCButton
              className={'mc-dropdown-menu-icon'}
              tiny
              onClick={(e) => {
                e.preventDefault();
                setOpen(!isOpen);
              }}
              transparent
            >
              <SVGIcon
                width={48}
                iconname={BASE_ICONS.HAMBURG}
                fill={variables['colors-mc-primary']}
              />
            </MCButton>
            <View style={{ position: 'absolute', top: remCss(75), right: remCss(26) }}>
              <LangSelect width={remCss(200)} />
            </View>
            <View
              className={'mc-dropdown-menu-list'}
              style={{ padding: remCss(38), gap: remCss(38), top: remCss(112) }}
            >
              {tabs?.map((tab, index) => (
                <View
                  key={index}
                  style={{
                    flexDirection: 'row'
                  }}
                >
                  <MCButton
                    onClick={() => {
                      setOpen(false);
                      onActiveTab(tab.id);
                    }}
                    transparent
                    tertiary
                    hover={activeTab !== tab.id}
                    tiny
                    style={{ gap: 'space-between' }}
                  >
                    <MCText
                      label={tab.label}
                      size={22}
                      weight={500}
                      textLight={activeTab !== tab.id}
                      primary={activeTab === tab.id}
                      lineHeight={21}
                    />
                  </MCButton>
                </View>
              ))}
              <View style={{ flexDirection: 'row' }}>
                <MCButton
                  onClick={() => {
                    setOpen(false);
                    navigate('/');
                  }}
                  transparent
                  tertiary
                  hover
                  tiny
                  style={{ gap: 'space-between' }}
                >
                  <MCText
                    label={LANG_CONST.buttons.back_to_app}
                    size={22}
                    weight={500}
                    textLight
                    lineHeight={21}
                  />
                </MCButton>
              </View>
            </View>
          </View>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: remCss(5),
          paddingHorizontal: remCss(15)
        }}
      >
        {tabs.map((tab) => {
          const active = activeTab === tab.id;
          return (
            <MCButton
              type={'button'}
              key={tab.id}
              style={{
                padding: `${remCss(8)}px ${remCss(10)}px`,
                backgroundColor: active ? variables['colors-mc-primary'] : 'transparent',
                color: active ? 'white' : variables['colors-mc-text-primary'],
                fontSize: remFontCss(18)
              }}
              transparent
              radius
              onClick={() => onActiveTab(tab.id)}
              label={tab.label}
            />
          );
        })}
      </View>
    </View>
  );
};
